module.exports = __webpack_public_path__ + "static/media/land-of-dreams.e196056e.jpg";